// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "elixio-connect-vue2.umd." + chunkId + ".js";
};